import { Link } from "react-router-dom";
import NewsletterForm from "@/components/NewsletterForm";
import { Wordmark } from "@/components/Navbar";
import { BRAND, SERVICES } from "@/lib/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-24 border-t border-[#272B36] bg-[#0B0C10]">
      <div className="absolute inset-x-0 top-0 rule-brass" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 md:py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Link to="/" aria-label="Upload Counsel home"><Wordmark /></Link>
            <p className="mt-5 max-w-md text-slate-400 text-sm leading-relaxed">
              The legal desk for creators. Send one request; a licensed attorney reviews it and matches you with vetted counsel in our network.{" "}
              <span className="text-slate-500">Operated by a licensed attorney. Not a law firm.</span>
            </p>
            <div className="mt-8">
              <p className="eyebrow">The Brief</p>
              <p className="mt-2 text-sm text-slate-400">Creator-economy legal news, once a week. No spam.</p>
              <div className="mt-3 max-w-md">
                <NewsletterForm source="footer" />
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow">Practice areas</p>
            <ul className="mt-4 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-sm text-slate-300 hover:text-[#F4F1EA]">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="eyebrow">Upload Counsel</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/start" className="text-slate-300 hover:text-[#F4F1EA]">Start a request</Link></li>
              <li><Link to="/how-it-works" className="text-slate-300 hover:text-[#F4F1EA]">How it works</Link></li>
              <li><Link to="/about" className="text-slate-300 hover:text-[#F4F1EA]">About</Link></li>
              <li><Link to="/attorneys" className="text-slate-300 hover:text-[#F4F1EA]">For attorneys</Link></li>
              <li><a href={`mailto:${BRAND.email}`} className="text-slate-300 hover:text-[#F4F1EA]">{BRAND.email}</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="eyebrow">Resources</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/blog" className="text-slate-300 hover:text-[#F4F1EA]">Insights</Link></li>
              <li><Link to="/brief" className="text-slate-300 hover:text-[#F4F1EA]">The Brief archive</Link></li>
              <li><Link to="/resources/brand-deal-checklist" className="text-slate-300 hover:text-[#F4F1EA]">Brand deal checklist</Link></li>
            </ul>
            <p className="eyebrow mt-8">Legal</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/legal/disclaimer" className="text-slate-300 hover:text-[#F4F1EA]">Attorney disclaimer</Link></li>
              <li><Link to="/legal/privacy" className="text-slate-300 hover:text-[#F4F1EA]">Privacy policy</Link></li>
              <li><Link to="/legal/terms" className="text-slate-300 hover:text-[#F4F1EA]">Terms of use</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#272B36] flex flex-col md:flex-row gap-4 items-start md:items-end justify-between">
          <p className="text-xs text-slate-500 max-w-3xl leading-relaxed">
            <span className="text-slate-300 font-medium">Attorney advertising.</span> This site is general information, not legal advice.
            Sending a request does not create an attorney-client relationship; that begins only with a signed engagement letter with a specific attorney.
            Past results do not guarantee future outcomes.
            {BRAND.responsible_attorney
              ? <> Responsible attorney: {BRAND.responsible_attorney}, licensed in {BRAND.bar_state}.</>
              : <> Operated by an attorney licensed in {BRAND.bar_state}.</>}{" "}
            See the <Link to="/legal/disclaimer" className="text-[#D9B36C] underline underline-offset-2">full disclaimer</Link>.
          </p>
          <p className="text-xs text-slate-500 shrink-0">© {new Date().getFullYear()} Upload Counsel</p>
        </div>
      </div>
    </footer>
  );
}
